import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {SystemEntity} from './system.entity';

@EntityTable('system_version', '8eb90775-de8a-403e-8d3b-f29e7589172c')
export class SystemVersionEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;


}
